import React from "react";
import { ModalBody, ModalHeader, ModalFooter, ButtonGroup, Button, Modal } from "reactstrap";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { userModalDataColumns } from "./dataColumns";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
const NewUserModal = ({ isOpen, updateUserProps, deleteUserProps, mergeUserProps, createUsers, newUsers, isUserCreating }) => {
  const userRows = newUsers || [];

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        updateUserProps([{ prop: "isNewUserModalOpen", value: !isOpen }]);
      }}
      className="modal-xl users-modal"
    >
      <ModalHeader
        toggle={() => {
          updateUserProps([{ prop: "isNewUserModalOpen", value: !isOpen }]);
        }}
      >
        <div>
          <div className="users-modal__eyebrow">Account Intake</div>
          <span className="users-modal__title">Create Users</span>
          <div className="users-modal__helper">
            Add user accounts in batches with ITS, email, and role details before creating them.
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="users-modal__body">
        <div className="users-modal__summary">
          <div className="users-modal__summary-item">
            <span className="users-modal__summary-label">Batch</span>
            <span className="users-modal__summary-value">New users</span>
          </div>
          <div className="users-modal__summary-item">
            <span className="users-modal__summary-label">Rows</span>
            <span className="users-modal__summary-value">{userRows.length}</span>
          </div>
          <div className="users-modal__summary-item">
            <span className="users-modal__summary-label">Fields</span>
            <span className="users-modal__summary-value">ITS, name, email, role</span>
          </div>
        </div>

        <div className="users-modal__toolbar">
          <ButtonGroup>
          <Button
            color={"faiz1"}
            onClick={() => {
              mergeUserProps([{ prop: "newUsers", value: [{ name: "", its: "", email: "", position: "" }] }]);
            }}
          >
            <i className={"fa fa-plus"} /> Add User
          </Button>
        </ButtonGroup>
        </div>

        <div className="users-modal__workspace">
          <div className="users-modal__workspace-header">
            <div>
              <div className="users-modal__workspace-title">Batch Editor</div>
              <div className="users-modal__workspace-copy">
                Enter each user row directly in the grid, then create the full batch together.
              </div>
            </div>
          </div>

          <div className="users-modal__table-shell">
        <ReactTable
          data={userRows}
          columns={userModalDataColumns(updateUserProps, deleteUserProps)}
          className="-highlight -striped users-table"
          defaultPageSize={5}
        />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="success"
          onClick={() => {
            // updateUserProps([{ prop: "isNewUserModalOpen", value: !isOpen }]);
            createUsers(newUsers);
          }}
        >
          {isUserCreating ? (
            <>
              <Spinner size={10} animating={true} color={"white"} />
              &nbsp;
            </>
          ) : null}
          Create
        </Button>{" "}
        <Button
          color="secondary"
          onClick={() => {
            updateUserProps([{ prop: "isNewUserModalOpen", value: !isOpen }, { prop: "newUsers", value: [] }]);
          }}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default NewUserModal;
